export default "__VITE_ASSET__DmNyKiMj__"